import { QUERY_RESPONSE_RECEIVED } from '@web-platform/shared-universal-constants/src/network';
import {
  MICHELIN_GET_HOTEL_CARHIRE_CREATE_SEARCH,
  MICHELIN_GET_HOTEL_CARHIRE_POLLING,
} from '@web-platform/shared-universal-types/src/network/requestTypes';

import type { SkyscannerMichelinSearchV1Search } from '@skyscanner-internal/michelin-web-http-client';
import type { Action } from '@web-platform/shared-universal-types/src/redux/banana/actions/actions-banana-types';
import type { HotelIndicativePricingState } from '@web-platform/shared-universal-types/src/redux/banana/state/shared/michelin/hotelIndicativePricing';

type SearchResponse = SkyscannerMichelinSearchV1Search.SearchResponse;

export const INITIAL_STATE: HotelIndicativePricingState = {};

const transformHotelIndicativePricingData = (
  response: SearchResponse,
  state: HotelIndicativePricingState = INITIAL_STATE,
): HotelIndicativePricingState => {
  const hotelIndicativePricesSection = response.sections?.find(
    (section) => section?.hotelIndicativePrices,
  );

  if (!hotelIndicativePricesSection?.hotelIndicativePrices) {
    return state;
  }

  return hotelIndicativePricesSection.hotelIndicativePrices;
};

export default (
  state: HotelIndicativePricingState = INITIAL_STATE,
  action: Action,
): HotelIndicativePricingState => {
  switch (action.type) {
    case QUERY_RESPONSE_RECEIVED: {
      const { response, type } = action.payload;

      if (
        (type === MICHELIN_GET_HOTEL_CARHIRE_CREATE_SEARCH ||
          type === MICHELIN_GET_HOTEL_CARHIRE_POLLING) &&
        response?.body &&
        typeof response.body === 'object' &&
        'sections' in response.body
      ) {
        return transformHotelIndicativePricingData(response.body, state);
      }

      return state;
    }
    default:
      return state;
  }
};

export const get = (state: HotelIndicativePricingState): HotelIndicativePricingState => state;
